import { combineReducers } from 'redux';
import * as admin from '@benniehealth/core-js/store/admin';

import exports from './exports';
import sso from './sso';
import subsidiaries from './subsidiaries';
import users from './users';

export default combineReducers({
  exports,
  sso,
  subsidiaries,
  users,
  perks: admin.perks.slice,
});
